<template>
  <div v-if="checkAccess()">
    <button @click="enterCabinet" class="btn btn-accent btn-sm">
      Зайти в аккаунт
    </button>
  </div>
</template>

<script>
import { useStore } from "vuex";
import { computed } from "@vue/runtime-core";
export default {
  props: {
    id: {
      type: Number,
    },
    role: {
      type: String,
    }
  },
  setup(props) {
    const store = useStore();
    const role = computed(() =>
        store.state.profile.profile
          ? store.state.profile.profile.role
          : "private_person"
      ),
      token = computed(() => store.state.users.userToken);
    const enterCabinet = () => {
      store.commit("setIsGlobalLoad", true);
      store
        .dispatch("users/getUserToken", props.id)
        .then(() => {
          if (token.value) {
            if (!localStorage.getItem("prevToken"))
              localStorage.setItem(
                "prevToken",
                document.cookie.match(new RegExp("ei-token=([^;]*)"))[1]
              );
            window.location.href = `${process.env.VUE_APP_BACK}/auth/${token.value}`;
          }
        })
        .finally(() => store.commit("setIsGlobalLoad", false));
    };

    const checkAccess = () => {
      switch (role.value) {
        case "superadmin":
          return true;
        case "admin":
          return props.role === "Сотрудник";
      }
    };

    return {
      enterCabinet,
      checkAccess,
    };
  },
};
</script>

<style lang="scss" scoped>
a {
  width: 100%;
  display: block;
  &:hover {
    color: var(--hover-color);
  }
}
</style>